import { REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENVIRONMENT } from '../configs';

let initPromise: Promise<void> | null = null;

export function initSentry(): Promise<void> {
  if (!REACT_APP_SENTRY_DSN) {
    return Promise.resolve();
  }

  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    const Sentry = await import('@sentry/react');
    const { BrowserTracing } = await import('@sentry/tracing');

    Sentry.init({
      dsn: REACT_APP_SENTRY_DSN,
      integrations: [new BrowserTracing()],
      tracesSampleRate: 1.0,
      environment: REACT_APP_SENTRY_ENVIRONMENT,
    });
  })();

  return initPromise;
}

/** Await Sentry SDK before capture* calls (e.g. Auth0 callback). */
export async function ensureSentryInitialized(): Promise<void> {
  await initSentry();
}

/** Load Sentry after first paint; also init on first uncaught error. */
export function scheduleSentryInit(): void {
  if (typeof window === 'undefined' || !REACT_APP_SENTRY_DSN) {
    return;
  }

  requestAnimationFrame(() => {
    void initSentry();
  });

  const initOnError = () => {
    void initSentry();
  };

  window.addEventListener('error', initOnError, { once: true });
  window.addEventListener('unhandledrejection', initOnError, { once: true });
}
